var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2792 17.6667C20.8382 17.6667 21.149 17.02 20.7997 16.5835L16.8535 11.6507C16.5866 11.3171 16.0792 11.3171 15.8123 11.6507L11.8661 16.5835C11.5169 17.02 11.8277 17.6667 12.3867 17.6667L13.7296 17.6667C14.0721 17.6667 14.3589 17.9262 14.393 18.267L14.8795 23.1327C14.9477 23.8143 15.5212 24.3333 16.2062 24.3333H16.4596C17.1446 24.3333 17.7182 23.8143 17.7863 23.1327L18.2729 18.267C18.307 17.9262 18.5937 17.6667 18.9362 17.6667L20.2792 17.6667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7197 24.3334C21.1607 24.3334 20.8499 24.98 21.1991 25.4165L25.1453 30.3494C25.4122 30.683 25.9196 30.683 26.1865 30.3494L30.1328 25.4165C30.482 24.98 30.1712 24.3334 29.6122 24.3334H28.2692C27.9267 24.3334 27.64 24.0739 27.6059 23.7331L27.1193 18.8674C27.0512 18.1858 26.4776 17.6667 25.7926 17.6667L25.5392 17.6667C24.8542 17.6667 24.2807 18.1858 24.2125 18.8674L23.726 23.7331C23.6919 24.0739 23.4051 24.3334 23.0626 24.3334H21.7197Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.cb72bf6da7beadbb773e1bfa9f89697e.svg";
export { ForwardRef as ReactComponent };